import React from 'react';

import { Icon } from '@/new/components/icon';
import { SearchInput } from '@/new/components/search-input';
import { Button } from '@/new/components/shadcn/button';

interface TableSearchBoxProps {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onSearchCall: (value: string) => void;
}

export const TableSearchBox = ({ value, placeholder, onChange, onSearchCall }: TableSearchBoxProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearchCall(value);
    }
  };

  return (
    <div
      className="flex min-w-md grow rounded-md ring-offset-2 transition-colors duration-150 has-[input:focus]:ring has-[input:focus]:ring-teal-500"
      data-testid="table-search-box"
    >
      <SearchInput
        className="grow rounded-r-none focus-within:ring-0"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <Button
        type="button"
        aria-label="Submit search"
        className="-ml-px rounded-l-none"
        onClick={() => onSearchCall(value)}
      >
        <Icon className="lucide--arrow-right" />
      </Button>
    </div>
  );
};
